import { getStage } from './env';

const apiBaseMap: Record<string, string> = {
    dev: 'https://3ewjdxae17.execute-api.us-west-2.amazonaws.com/prod',
    beta: 'https://3ewjdxae17.execute-api.us-west-2.amazonaws.com/prod',
    gamma: 'https://8l8umomisk.execute-api.us-west-2.amazonaws.com/prod',
};

export const getApiBaseUrl = () => {
    const env = getStage();
    return apiBaseMap[env] || apiBaseMap['dev'];
};
